// apps/web/src/components/detail/DetailActionBar.tsx
import { Button } from "@/components/ui/button";
import { ExportButton } from "@/components/export/ExportButton";
import type { EntityRef } from "@/lib/export";

export interface DetailActionBarProps {
  url: string;
  watched: boolean;
  onToggleWatch: (next: boolean) => void;
  /**
   * When provided, renders an SP5 "Export PDF" button alongside the existing
   * copy-link + watch toggle. Kept optional to preserve backward compatibility
   * with callers that predate SP5; all three detail pages now pass it.
   */
  entity?: EntityRef;
}

export function DetailActionBar({ url, watched, onToggleWatch, entity }: DetailActionBarProps) {
  async function copyLink() {
    await navigator.clipboard.writeText(url);
  }
  return (
    <div className="flex gap-2">
      <Button variant="ghost" size="sm" onClick={copyLink}>Copy link</Button>
      <Button
        variant={watched ? "default" : "outline"}
        size="sm"
        onClick={() => onToggleWatch(!watched)}
      >
        {watched ? "Watching" : "Watch"}
      </Button>
      {entity ? <ExportButton entity={entity} /> : null}
    </div>
  );
}
